export function convertScreenWidth(screenWidth, breakpointUnit) {
    return breakpointUnit === 'em' ? screenWidth / 16 : screenWidth;
}
//# sourceMappingURL=convertScreenWidth.js.map